import { useCallback } from "react";
import { useSetRecoilState } from "recoil";

import {
  ConfirmResult,
  dataChangedConfirmRideAtom,
  IChangedDataItem,
  IPassengerInfo,
  IRideCancelModalResult,
  IRideDto,
  PassengerDeleteResultEnum,
  rideArchiveConfirmAtom,
  rideCancelConfirmAtom,
  RideDeleteActionsResultEnum,
  ridePassengerDeleteConfirmAtom,
  RideStationPanelMode,
} from "@ryde/shared";

import { useSelectedIds } from "../use-selected-ids";

export const useModalConfirmsRide = () => {
  const { selectedRowsIds } = useSelectedIds();
  const setPassConfirmInfo = useSetRecoilState(ridePassengerDeleteConfirmAtom);
  const setDataChangeConfirmInfo = useSetRecoilState(
    dataChangedConfirmRideAtom,
  );
  const setRideArchiveConfirmInfo = useSetRecoilState(rideArchiveConfirmAtom);
  const setRideCancelConfirmInfo = useSetRecoilState(rideCancelConfirmAtom);

  const confirmRidePassengerDeleteBookingAction = useCallback(
    ({
      passengers,
      mode,
      ride,
    }: {
      passengers: IPassengerInfo[];
      mode: RideStationPanelMode;
      ride: IRideDto;
    }): Promise<PassengerDeleteResultEnum> => {
      return new Promise(resolve => {
        setPassConfirmInfo({ passengers, mode, ride, resolveFn: resolve });
      });
    },
    [setPassConfirmInfo],
  );

  const confirmDataChangedAction = useCallback(
    (changesList: IChangedDataItem[]): Promise<ConfirmResult> => {
      return new Promise(resolve => {
        setDataChangeConfirmInfo({ changesList, resolveFn: resolve });
      });
    },
    [setDataChangeConfirmInfo],
  );

  const confirmRideCancelAction = useCallback(
    (options?: {
      requireCancelationReason?: boolean;
    }): Promise<IRideCancelModalResult> => {
      return new Promise(resolve => {
        setRideCancelConfirmInfo({
          rideIds: selectedRowsIds,
          requireCancelationReason: options?.requireCancelationReason,
          resolveFn: resolve,
        });
      });
    },
    [selectedRowsIds, setRideCancelConfirmInfo],
  );

  const confirmRideArchiveAction =
    useCallback((): Promise<RideDeleteActionsResultEnum> => {
      return new Promise(resolve => {
        setRideArchiveConfirmInfo({ resolveFn: resolve });
      });
    }, [setRideArchiveConfirmInfo]);

  return {
    confirmRidePassengerDeleteBookingAction,
    confirmDataChangedAction,
    confirmRideArchiveAction,
    confirmRideCancelAction,
  };
};
